import request from '@/common/request'
// // 登录
// export function getUserLogin(data) {
//   return request.post('/user/login?account=' + data.account + '&pass=' + data.pass)
// }
// export function getUserInfo() {
//   return request.get('/getUserInfo')
// }
//用户登录
export const getUserLogin = (data) => {
  return request.post('/login', data)
}
//获取用户信息
export const getUserInfo = (params) => {
  return request.get('/getUserInfo', { params })
}
// 获取图片验证码
export const getCaptcha = (params) => {
  return request.get('/captcha', { params })
}
// 核对拼图验证码
export const getCheckCaptcha = (params) => {
  return request.get('/checkCaptcha', { params })
}
export const updValidManagement = (params) => {
  return request.get('/system/supplier/updValid', { params })
}
